module.exports = __webpack_public_path__ + "static/media/loading.1b655567.svg";